<div class="app-container">
  <app-toolbar class="app-toolbar"></app-toolbar>
  <router-outlet></router-outlet>
</div>
